import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../contexts/AuthContext";
import { GoogleLogin } from "@react-oauth/google";

const AdminLogin = () => {
  const [password, setPassword] = useState("");
  const [googleToken, setGoogleToken] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!password || !googleToken) {
      setError("Потрібно ввести пароль та підтвердити Google акаунт");
      return;
    }

    setLoading(true);
    setError(null);

    try {
      await login(password, googleToken);
      navigate("/infoplace/dashboard");
    } catch (err) {
      setError("Невірний пароль або Google акаунт");
      console.error("Login error:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <main style={styles.loginContainer}>
      <form style={styles.loginForm} onSubmit={handleSubmit}>
        <img src="/assets/icons/210-logo.svg" alt="Логотип" style={styles.logo} />
        <h1 style={styles.title}>Авторизуйтеся</h1>

        <input
          style={styles.input}
          type="password"
          placeholder="Пароль"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />

        <div style={{ margin: "1rem 0" }}>
          <GoogleLogin
            onSuccess={(res) => {
              if (res.credential) setGoogleToken(res.credential);
            }}
            onError={() => setError("Помилка Google авторизації")}
          />
        </div>

        <button
          type="submit"
          style={{
            ...styles.button,
            backgroundColor: loading ? "#aaa" : "green",
            cursor: loading ? "not-allowed" : "pointer",
          }}
          disabled={loading}
        >
          {loading ? "Авторизація..." : "Увійти"}
        </button>

        {error && <p style={styles.errorMessage}>{error}</p>}
      </form>
    </main>
  );
};

const styles: Record<string, React.CSSProperties> = {
  loginContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "100vh",
    backgroundColor: "#f5f5f5",
  },
  loginForm: {
    backgroundColor: "white",
    borderRadius: "8px",
    padding: "2rem",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
    width: "100%",
    maxWidth: "400px",
    textAlign: "center",
  },
  logo: {
    width: "var(--header-height)",
    marginBottom: "1rem",
  },
  title: {
    fontSize: "1.5rem",
    marginBottom: "1.5rem",
    color: "var(--secondary-color)",
  },
  input: {
    width: "100%",
    padding: "0.8rem",
    marginBottom: "1rem",
    border: "1px solid #ddd",
    borderRadius: "4px",
  },
  button: {
    width: "100%",
    padding: "0.8rem",
    backgroundColor: "green",
    color: "white",
    border: "none",
    borderRadius: "4px",
    fontWeight: 500,
    cursor: "pointer",
    transition: "background-color 0.3s",
  },
  errorMessage: {
    color: "red",
    margin: "1rem 0",
    fontSize: "0.9rem",
  },
};

export default AdminLogin;
